import axios from 'axios'
import { Message } from 'element-ui'
import { getToken, removeToken } from './auth'
import router from '../router'
import store from '../store'

const request = axios.create({
  baseURL: '/api',
  timeout: 10000
})

// 请求拦截：附加 Token
// request.interceptors.request.use(config => {
//   const token = getToken()
//   if (token) {
//     config.headers['Authorization'] = 'Bearer ' + token
//   }
//   return config
// })
request.interceptors.request.use(config => {
  const token = getToken()
  console.log('当前token:', token) // 添加这行
  if (token) {
    config.headers['Authorization'] = 'Bearer ' + token
    console.log('请求头:', config.headers) // 添加这行
  } else {
    console.warn('没有token!') // 添加这行
  }
  return config
})

// 响应拦截：统一错误处理
request.interceptors.response.use(
  res => {
    // blob 类型直接返回
    if (res.config.responseType === 'blob') return res.data
    const data = res.data
    if (data.code === 200) return data
    if (data.code === 401) {
      removeToken()
      store.commit('user/RESET')
      Message.error(data.msg || '未登录或登录已过期')
      router.replace('/login')
      const e401 = new Error(data.msg)
      e401.handled = true
      return Promise.reject(e401)
    }
    Message.error(data.msg || '请求失败')
    const e = new Error(data.msg)
    e.handled = true
    return Promise.reject(e)
  },
  err => {
    Message.error(err.response?.data?.msg || err.message || '网络错误')
    err.handled = true
    return Promise.reject(err)
  }
)

export default request
